import React from "react";
import styles from "./SubmitButton.module.css";

export interface SubmitButtonProps {
  label: string;
  isLoading?: boolean;
  type?: "button" | "submit";
  disabled?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  backgroundColor?: string;
  textColor?: string;
  borderRadius?: number;
}

export const SubmitButton: React.FC<SubmitButtonProps> = ({
  label,
  isLoading,
  type = "submit",
  disabled,
  onClick,
  backgroundColor,
  textColor,
  borderRadius,
}) => (
  <button
    type={type}
    className={`${styles.button} ${isLoading ? styles.loading : ""}`}
    disabled={disabled || isLoading}
    aria-busy={isLoading}
    aria-live="polite"
    aria-label={isLoading ? "Procesando, por favor espere" : label}
    onClick={onClick}
    style={
      {
        "--submit-btn-bg-color": backgroundColor,
        "--submit-btn-text-color": textColor,
        "--submit-btn-border-radius": borderRadius
          ? `${borderRadius}px`
          : undefined,
      } as React.CSSProperties
    }
  >
    {isLoading ? "Procesando..." : label}
  </button>
);
